const times = [
  {
    value: "00:00:00",
    time: "12:00:00",
    meridiem: "AM"
  },
  {
    value: "00:30:00",
    time: "12:30:00",
    meridiem: "AM"
  },
  {
    value: "01:00:00",
    time: "01:00:00",
    meridiem: "AM"
  },
  {
    value: "01:30:00",
    time: "01:30:00",
    meridiem: "AM"
  },
  {
    value: "02:00:00",
    time: "02:00:00",
    meridiem: "AM"
  },
  {
    value: "02:30:00",
    time: "02:30:00",
    meridiem: "AM"
  },
  {
    value: "03:00:00",
    time: "03:00:00",
    meridiem: "AM"
  },
  {
    value: "03:30:00",
    time: "03:30:00",
    meridiem: "AM"
  },
  {
    value: "04:00:00",
    time: "04:00:00",
    meridiem: "AM"
  },
  {
    value: "04:30:00",
    time: "04:30:00",
    meridiem: "AM"
  },
  {
    value: "05:00:00",
    time: "05:00:00",
    meridiem: "AM"
  },
  {
    value: "05:30:00",
    time: "05:30:00",
    meridiem: "AM"
  },
  {
    value: "06:00:00",
    time: "06:00:00",
    meridiem: "AM"
  },
  {
    value: "06:30:00",
    time: "06:30:00",
    meridiem: "AM"
  },
  {
    value: "07:00:00",
    time: "07:00:00",
    meridiem: "AM"
  },
  {
    value: "07:30:00",
    time: "07:30:00",
    meridiem: "AM"
  },
  {
    value: "08:00:00",
    time: "08:00:00",
    meridiem: "AM"
  },
  {
    value: "08:30:00",
    time: "08:30:00",
    meridiem: "AM"
  },
  {
    value: "09:00:00",
    time: "09:00:00",
    meridiem: "AM"
  },
  {
    value: "09:30:00",
    time: "09:30:00",
    meridiem: "AM"
  },
  {
    value: "10:00:00",
    time: "10:00:00",
    meridiem: "AM"
  },
  {
    value: "10:30:00",
    time: "10:30:00",
    meridiem: "AM"
  },
  {
    value: "11:00:00",
    time: "11:00:00",
    meridiem: "AM"
  },
  {
    value: "11:30:00",
    time: "11:30:00",
    meridiem: "AM"
  },
  {
    value: "12:00:00",
    time: "12:00:00",
    meridiem: "PM"
  },
  {
    value: "12:30:00",
    time: "12:30:00",
    meridiem: "PM"
  },
  {
    value: "13:00:00",
    time: "01:00:00",
    meridiem: "PM"
  },
  {
    value: "13:30:00",
    time: "01:30:00",
    meridiem: "PM"
  },
  {
    value: "14:00:00",
    time: "02:00:00",
    meridiem: "PM"
  },
  {
    value: "14:30:00",
    time: "02:30:00",
    meridiem: "PM"
  },
  {
    value: "15:00:00",
    time: "03:00:00",
    meridiem: "PM"
  },
  {
    value: "15:30:00",
    time: "03:30:00",
    meridiem: "PM"
  },
  {
    value: "16:00:00",
    time: "04:00:00",
    meridiem: "PM"
  },
  {
    value: "16:30:00",
    time: "04:30:00",
    meridiem: "PM"
  },
  {
    value: "17:00:00",
    time: "05:00:00",
    meridiem: "PM"
  },
  {
    value: "17:30:00",
    time: "05:30:00",
    meridiem: "PM"
  },
  {
    value: "18:00:00",
    time: "06:00:00",
    meridiem: "PM"
  },
  {
    value: "18:30:00",
    time: "06:30:00",
    meridiem: "PM"
  },
  {
    value: "19:00:00",
    time: "07:00:00",
    meridiem: "PM"
  },
  {
    value: "19:30:00",
    time: "07:30:00",
    meridiem: "PM"
  },
  {
    value: "20:00:00",
    time: "08:00:00",
    meridiem: "PM"
  },
  {
    value: "20:30:00",
    time: "08:30:00",
    meridiem: "PM"
  },
  {
    value: "21:00:00",
    time: "09:00:00",
    meridiem: "PM"
  },
  {
    value: "21:30:00",
    time: "09:30:00",
    meridiem: "PM"
  },
  {
    value: "22:00:00",
    time: "10:00:00",
    meridiem: "PM"
  },
  {
    value: "22:30:00",
    time: "10:30:00",
    meridiem: "PM"
  },
  {
    value: "23:00:00",
    time: "11:00:00",
    meridiem: "PM"
  },
  {
    value: "23:30:00",
    time: "11:30:00",
    meridiem: "PM"
  }
]

export const getAllTimes = () => times
